<template>
  <el-dialog :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true" :modal-append-to-body='false' :fullscreen="false" width="1500px">
    <div class="main-box" style="height: 600px">
      <div class="dialogTop">
        <xr-button type="primary" @click.native="getSelectedValue()">确定</xr-button>
        <xr-button type="default" @click.native="dialogVisible = false">取消</xr-button>
      </div>
      <xr-table-select ref="xrTable" :configure="configure" :right-data="rightData"></xr-table-select>
    </div>
  </el-dialog>
</template>

<script>
  import XrDataTable from '../../../XrTable/dataTable'

  //人员多选
  export default {
    name: "pageSelectOrgUser",
    data (){
      return {
        dialogName: '',
        dialogVisible: false,
        rightData: [],
        orgTreeId: '',
        layoutConfigure:{
          westWidth:'300px',
        },
        configure: {
          url: '/web/service?method=tCoreUser_pageSelectList',
          listParam: {
            orgId: ''
          },
          isShowSearch: true,
          defaultNoLoadData: true,
          isSelectFirst: false,
          pagination: false,
          idField: 'id',
          tableHeight: 570,
          columns: [
            {
              field: 'ck',
              width: 60,
            },
            {
              field: 'id',
              title: '账号',
              width: 120,
              condition: {
                searchType: 'input',
                searchName: 'idSearch',
                value: ''
              },
            },
            {
              field: 'userName',
              title: '用户名称',
              width: 120,
              condition: {
                searchType: 'input',
                searchName: 'userNameSearch',
                value:''
              },
            },
            {
              field: 'orgId',
              title: '所属部门',
              condition: {
                searchType: 'select',
                searchName: 'orgIdSearch',
                value:'',
                selectList:[]
              },
            }
          ],
        },
      }
    },
    components: {
      XrDataTable
    },
    methods: {
      init(ids,orgType, isOrgAuth, orgTreeId) {
        if(!!orgTreeId){
          this.orgTreeId = orgTreeId;
        }else{
          this.orgTreeId = 'userOrgMultipleOrgTree';
        }

        this.dialogVisible = true
        this.$nextTick(()=>{
          this.initData(ids, orgType);
        })
      },
      //初始化数据
      initData(ids, orgType){
        this.rightData = [];
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tCoreUser_getPageSelectListInfo'
          }
        }).then((response) =>{          //这里使用了ES6的语法
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if(response.code != '0'){
            this.$message.error(response.msg);
            return false;
          }
          let orgList = response.data.orgList;
          this.configure.columns[3].condition.selectList = orgList;
          this.configure.url = '/web/service?method=tCoreUser_pageSelectList&selectedIds=-1';
          this.configure.url = '/web/service?method=tCoreUser_pageSelectList&selectedIds=' + ids + '&orgType=' + orgType;
          this.$refs.xrTable.configure = this.configure;
          this.$refs.xrTable.getData();

        })
      },
      //根据组织树加载用户
      getData(id){
        this.configure.listParam['orgId'] = id
        this.$refs.xrTable.getData();
      },
      // //添加选中的用户
      // addSelectedUser(){
      //   //1、获取以前选中的数据
      //   let selectedData = this.dataConfigure.tableData;
      //   let selectedStr = ',';
      //   if(selectedData != null && selectedData.length > 0){
      //     for (let i = 0; i < selectedData.length; i++) {
      //       selectedStr += selectedData[i].id + ',';
      //     }
      //   }
      //
      //   //2、获取当前选中的，添加进右边的列表
      //   let list = this.$refs.xrTable.multipleSelectionItem
      //   if(list == null || list.length < 1){
      //     return false;
      //   }
      //   for (let i = 0; i < list.length; i++) {
      //     if(selectedStr.indexOf(',' + list[i].id + ',') == -1){
      //       selectedData.push(list[i]);
      //     }
      //   }
      //
      //   //3、将组装后的tableData放回去
      //   this.dataConfigure.tableData = selectedData;
      // },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      getSelectedValue(){
        let selectIds = '';
        let selectNames = '';
        let selectedData = this.rightData;
        if(selectedData == null || selectedData.length < 1){
          alert('请选择！');
          return false;
        }
        for (let i = 0; i < selectedData.length; i++) {
          if(selectIds == ''){
            selectIds = selectedData[i].id;
            selectNames = selectedData[i].userName;
          }else{
            selectIds += ',' + selectedData[i].id;
            selectNames += ',' + selectedData[i].userName;
          }
        }
        this.$emit('confirmMethod',selectIds,selectNames);
        this.dialogVisible = false
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/PageSelect/core/user/userOrgMultiplePageSelect.vue